module.exports = __webpack_public_path__ + "assets/gravity-forms.509b3a75.svg";